import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { TabsWrapper } from '../../../DealTypeTabs';
import { SearchTabs } from '../../../../ui/SearchTabs';
import { TabVariantEnum } from '../../../../ui/SearchTabs/types';
import { ItemCreateContactTypeEnum } from '../../../../../graphql/types';

const ownerType = [
  {
    value: ItemCreateContactTypeEnum.Owner,
    name: 'new_ad.i_am_owner',
    id: 'new-ad-form-owner'
  },
  {
    value: ItemCreateContactTypeEnum.Agent,
    name: 'new_ad.i_am_agent',
    id: 'new-ad-form-agent'
  }
];

export const OwnerOrAgent: React.FC = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const handleTabClick = (value: string) => {
    change(FORM_VALUES.owner, value);
  };

  const tabsTitles = ownerType.map(type => ({
    name: type.id,
    label: t(type.name),
    isSelected: type.value === values[FORM_VALUES.owner],
    stat: type.id,
    onClick: () => handleTabClick(type.value)
  }));

  return (
    <TabsWrapper>
      <SearchTabs
        titles={tabsTitles}
        disabled={false}
        variant={TabVariantEnum.Blue}
        height={54}
      />
    </TabsWrapper>
  );
};
